import { TableauExpressionLexer } from '@tableau/tableau-expression-parser-js';
import { InputStream, Token } from 'antlr4';

export function tokensFromTableauExpression(expression: string): ReadonlyArray<Token> {
  const inputStream = new InputStream(expression);
  const lexer = new TableauExpressionLexer(inputStream);
  lexer.removeErrorListeners();
  const tokens = lexer.getAllTokens();
  return tokens;
}

export function trimBrackets(expression: string): string {
  const firstBracket = expression.indexOf('[');
  if (firstBracket !== -1) {
    const lastBracket = expression.lastIndexOf(']');
    if (lastBracket !== -1) {
      return unescapeBrackets(expression.substr(firstBracket + 1, lastBracket - firstBracket - 1));
    } else {
      return unescapeBrackets(expression.substr(firstBracket + 1));
    }
  }
  return expression;
}

export function unescapeBrackets(expression: string): string {
  return expression.replace(/]]/g, ']');
}
